function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var HerramientaDibujoBase = function () {
  function HerramientaDibujoBase(nombre, color, grosor) {
    var _this = this;

    _classCallCheck(this, HerramientaDibujoBase);

    this.down = function (ctx, x, y, dataURL) {
      _this.dataURL = dataURL;

      _this.herramientaDown(ctx, x, y);
    };

    this.move = function (ctx, x, y) {
      _this.herramientaMove(ctx, x, y);
    };

    this.up = function (ctx, x, y, callback) {
      if (_this.dataURL) {
        _this.pintarDataURL(ctx, callback);
      } else {
        _this.borrarCanvas(ctx);

        if (_this.herramientaUp) {
          _this.herramientaUp(ctx, x, y);
        }

        if (callback) {
          callback();
        }
      }
    };

    this.getCursor = function () {
      return 'cursor' + _this.nombre;
    };

    this.pintarDataURL = function (ctx, callback) {
      var img = new Image();

      var loadImg = function loadImg() {
        img.removeEventListener('load', loadImg, false);

        _this.borrarCanvas(ctx);

        ctx.drawImage(img, 0, 0); //, this.sw, this.sh, 0, 0, this.sw, this.sh);

        if (_this.herramientaUp) {
          _this.herramientaUp(ctx);
        }

        if (callback) {
          callback();
        }
      };

      img.addEventListener('load', loadImg, false);
      img.src = _this.dataURL;
    };

    this.borrarCanvas = function (ctx) {
      ctx.globalCompositeOperation = 'source-over';
      var _ctx$canvas = ctx.canvas,
          width = _ctx$canvas.width,
          height = _ctx$canvas.height;
      ctx.clearRect(0, 0, width, height);
    };

    this.nombre = nombre;
    this.color = color;
    this.grosor = grosor;
  }

  HerramientaDibujoBase.prototype.setGrosor = function setGrosor(grosor) {
    this.grosor = grosor;
  };

  HerramientaDibujoBase.prototype.setColor = function setColor(color) {
    this.color = color;
  };

  return HerramientaDibujoBase;
}();

export default HerramientaDibujoBase;